import { lockBodyScroll, unlockBodyScroll } from '@utils/scrollLock';

// Imperative body-level UI effects for the mobile nav overlays, kept out of the
// MobX actions in ModalsStore so the store holds observable state rather than DOM
// mutations. Behavior is unchanged from the inline versions:
//   - `.body-no-scroll` (SCSS) locks scroll and sizes the body to the viewport.
//   - `is-filter-opened` / `show-catalog` are state hooks consumed by other SCSS.
//   - The ref-counted scroll-lock util keeps the filters overlay consistent with
//     the shared modal scroll-lock system.

/** Toggle the body state for the mobile catalog filters overlay. */
export const setMobileFiltersBodyState = (open: boolean): void => {
  if (open) {
    document.body.classList.add('is-filter-opened', 'body-no-scroll');
    lockBodyScroll();
  } else {
    document.body.classList.remove('is-filter-opened', 'body-no-scroll');
    unlockBodyScroll();
  }
};

/** Toggle the body state for the mobile main (catalog) menu overlay. */
export const setMobileMenuBodyState = (open: boolean): void => {
  if (open) {
    document.body.classList.add('body-no-scroll', 'show-catalog');
  } else {
    document.body.classList.remove('body-no-scroll', 'show-catalog');
  }
};
